import { render, staticRenderFns } from "./buyTel.vue?vue&type=template&id=06efa571&scoped=true"
import script from "./buyTel.vue?vue&type=script&lang=js"
export * from "./buyTel.vue?vue&type=script&lang=js"
import style0 from "./buyTel.vue?vue&type=style&index=0&id=06efa571&prod&scoped=true&lang=css"
import style1 from "./buyTel.vue?vue&type=style&index=1&id=06efa571&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06efa571",
  null
  
)

export default component.exports